var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
};

export default {
    getAgeFromIdCard : function(idCard){
        const birthday = idCard.match(/\d{6}(\d{4})(\d{2})(\d{2})/);
        if (birthday) {
          const year = parseInt(birthday[1]);
          const month = parseInt(birthday[2]); //0124 1
          // const day = parseInt(birthday[3]);
          const today = new Date();
          let age = today.getFullYear() - year;
          //0 12
          // if (today.getMonth() <  month - 1 || (today.getMonth() == month - 1 && today.getDate() < day)) {
          if (today.getMonth() <  month - 1) {
            age--;
          }
          return age;
        } else {
          return -1; // 身份证号不合法
        }
    },
    getSexFromIdCard : function(idCard){
        if (!idCard || idCard.length !== 18) {
          throw new Error('Invalid ID card number');
        }
        const sexCode = idCard.charAt(16);
        return sexCode % 2 === 0 ? 1 : 0;
    },
    getQueryStringByName: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    getCurrentDay(){
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth() + 1;
        var date = now.getDate();
        return year + '-' + (String(month).length > 1 ? month : '0' + month) + '-' +
                  (String(date).length > 1 ? date : '0' + date)
    },
    formatDate: {
        format: function (date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y': return padding(date.getFullYear(), $0.length);
                    case 'M': return padding(date.getMonth() + 1, $0.length);
                    case 'd': return padding(date.getDate(), $0.length);
                    case 'w': return date.getDay() + 1;
                    case 'h': return padding(date.getHours(), $0.length);
                    case 'm': return padding(date.getMinutes(), $0.length);
                    case 's': return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y': _date.setFullYear(_int); break;
                        case 'M': _date.setMonth(_int - 1); break;
                        case 'd': _date.setDate(_int); break;
                        case 'h': _date.setHours(_int); break;
                        case 'm': _date.setMinutes(_int); break;
                        case 's': _date.setSeconds(_int); break;
                    }
                }
                return _date;
            }
            return null;
        },
        Time(now) {
            var year = now.getFullYear();
            var month = now.getMonth() + 1;
            var date = now.getDate();
            var hour = now.getHours();
            var minute = now.getMinutes();
            var second = now.getSeconds();
            return year + '-' + (String(month).length > 1 ? month : '0' + month) + '-' +
                (String(date).length > 1 ? date : '0' + date) + ' ' + (String(hour).length > 1 ? hour : '0' + hour) + ':' + (String(minute).length > 1 ? minute : '0' + minute)
                + ':' + (String(second).length > 1 ? second : '0' + second)
        },
        //获取当前时间，格式YYYY-MM-DD
        getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },

        //获取当前时间，格式YYYY-MM-DD
        getBeforeDay() {
            var date = new Date();
            date.setDate(date.getDate() - 1);
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },

        //获取当前时间前后N天前后日期的方法
        GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate() + AddDayCount);//获取AddDayCount天后的日期  
            var y = dd.getFullYear();
            var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0  
            var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();//获取当前几号，不足10补0  
            return y + "-" + m + "-" + d;
        },
        dataURLtoFile(dataurl, filename) {//将base64转换为文件
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        getCaption(obj) {//截取层后面的字符
            var index = obj.lastIndexOf("元");
            obj = obj.substring(index + 1, obj.length);
            console.log(obj);
            return obj;
        },
        getCaps(obj) {//截取第一个后面的字符
            var index = obj.indexOf("元");
            obj = obj.substring(index + 1, obj.length);
            console.log(obj);
            return obj;
        },
        //出生日期的年月日验证
        YearMonthDayValidate(year, month, day) {
            year = parseInt(year); //年
            month = parseInt(month);//月
            day = parseInt(day);//日
            //判断年，月,日是否为空
            if (isNaN(year) || isNaN(month) || isNaN(day)) return false;
            //判断月是否是在1-12月之间
            if (month < 1 || month > 12) return false;
            //返回当月的最后一天
            var date = new Date(year, month, 0);
            //判断是否超过天数范围
            if (day < 1 || day > date.getDate()) return false;
            return true;
        },
        //校验input不能输入特殊字符
        checkSpecialKey(str) {
            var specialKey = "[`~!#$^&*()-=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for (var i = 0; i < str.length; i++) {
                if (specialKey.indexOf(str.substr(i, 1)) != -1) {
                    return false;
                }
            }
            return true;
        },
    },

    // 手机号验证
    isvalidPhone: function (str) {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        return reg.test(str)
    },

    /*
    * JSON数组去重
    * @param: [array] json Array
    * @param: [string] 唯一的key名，根据此键名进行去重
    */
    uniqueArray(array, key) {
        var result = [array[0]];
        for (var i = 1; i < array.length; i++) {
            var item = array[i];
            var repeat = false;
            for (var j = 0; j < result.length; j++) {
                if (item[key] == result[j][key]) {
                    repeat = true;
                    break;
                }
            }
            if (!repeat) {
                result.push(item);
            }
        }
        return result;
    },

    /* 
      随机生成16进制颜色
    */
    getColor() {
        //定义字符串变量colorValue存放可以构成十六进制颜色值的值
        var colorValue = "0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f"; //以","为分隔符，将colorValue字符串分割为字符数组["0","1",...,"f"]
        var colorArray = colorValue.split(",");
        var color = "#"; //定义一个存放十六进制颜色值的字符串变量，先将#存放进去 //使用for循环语句生成剩余的六位十六进制值
        for (var i = 0; i < 6; i++) {
        //colorArray[Math.floor(Math.random()*16)]随机取出
        // 由16个元素组成的colorArray的某一个值，然后将其加在color中，
        //字符串相加后，得出的仍是字符串
        color += colorArray[Math.floor(Math.random() * 16)];
        }
        return color;
    },
};
